import {
  mountConfiguratorApplication,
  mountStandaloneAdminApplication,
} from '@salsita-ai/platform-project-sdk/application'

import { config } from './config'
import './ui/finalize/CustomSidebarFooter'

mountConfiguratorApplication(config)
mountStandaloneAdminApplication(config)
